import Eyebrow from './Eyebrow';

export default Eyebrow;
